import { apiCall, API_CONFIG } from './api';

export const crmAPI = {
  getCrmSummary: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.CRM_SUMMARY, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      return response;
    } catch (error) {
      console.error('Error fetching CRM summary:', error);
      throw error;
    }
  }
};